import { useState, useCallback } from "react";
import supabase from "../../../../../utils/supabase";
import { Student } from "../types";

interface UseStudentProgressProps {
  user: any;
  selectedClass: string;
  searchTerm: string;
  currentPage: number;
  limit: number;
}

export function useStudentProgress({
  user,
  selectedClass,
  searchTerm,
  currentPage,
  limit,
}: UseStudentProgressProps) {
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalStudents, setTotalStudents] = useState(0);

  const fetchStudents = useCallback(async () => {
    if (!user) return;

    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke(
        "getStudentsWithProgress",
        {
          body: {
            classId: selectedClass,
            search: searchTerm,
            limit,
            offset: (currentPage - 1) * limit,
          },
        }
      );

      if (error) {
        console.error("Error fetching students:", error);
        return;
      }

      setStudents(data.students || []);
      setTotalStudents(data.total || 0);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoading(false);
    }
  }, [user, selectedClass, searchTerm, currentPage, limit]);

  return {
    students,
    loading,
    totalStudents,
    fetchStudents,
  };
}
